import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {ReplyModel} from '@/models/reply.model';
import {take} from 'rxjs/operators';
import {ChallengeTopicMessagesApi} from '@/api/challenge-topic-messages.api';
import {EntityStateAdapter} from '@/store/base.store';
import {UserModel} from '@/models/user.model';

export const featureKey = 'forum_replies';

// @ts-ignore
if (store.state.forum_replies) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class ForumRepliesStore extends EntityStateAdapter<ReplyModel> {

  @Action({commit: 'insertMany', rawError: true})
  async fetchAll(data: {
    challengeId: number,
    topicId: number,
    page?: number,
  }): Promise<ReplyModel[]> {
    this.updateLoading(true);

    const response = await (new ChallengeTopicMessagesApi(data.challengeId, data.topicId))
      .allPaginated({page: data.page})
      .pipe(take(1))
      .toPromise();

    this.context.commit('updateAllPageParams', response);
    return response.data
  }

  @Action({commit: 'upsertOne', rawError: true})
  async updateReply(data: {
    challengerId: number,
    topicId: number,
    reply: ReplyModel,
  }): Promise<ReplyModel> {
    return await new ChallengeTopicMessagesApi(data.challengerId, data.topicId)
      .update(data.reply)
      .pipe(take(1))
      .toPromise()
  }

  @Action({commit: 'insertOne', rawError: true})
  async sendReply(data: {
    challengerId: number,
    topicId: number,
    reply: ReplyModel,
  }): Promise<ReplyModel> {
    return await new ChallengeTopicMessagesApi(data.challengerId, data.topicId)
      .create(data.reply)
      .pipe(take(1))
      .toPromise()
  }

  @Action({commit: 'removeOne', rawError: true})
  async destroyReply(data: {
    challengeId: number,
    topicId: number,
    replyId: number,
  }): Promise<number> {
    await (new ChallengeTopicMessagesApi(data.challengeId, data.topicId))
      .destroy(data.replyId)
      .pipe(take(1))
      .toPromise();
    return data.replyId
  }

  get entities(): ReplyModel[] {
    return super.entities;
  }

  get loading(): boolean {
    return super.loading;
  }

  get currentPage(): number {
    return super.currentPage;
  }

  get lastPage(): number {
    return super.lastPage;
  }

  get selectEntityOrderByCreatedAt(): ReplyModel[] {
    return super.selectEntityOrderByCreatedAt;
  }

  get selectEntityOrderByUpdatedAt(): ReplyModel[] {
    return super.selectEntityOrderByUpdatedAt;
  }

  get isAuthor(): (reply: ReplyModel, user: UserModel) => boolean {
    return (reply, user) => reply.contestant?.id === user?.contestant?.id
  }
}
